import { TooltipComponent } from '@angular/material/tooltip';

export function convertTooltipMessageToInnerHtml() {
	Object.defineProperty(TooltipComponent.prototype, 'message', {
		set(value: string) {
			const elementList = document.querySelectorAll('.mdc-tooltip');

			if (elementList) {
				elementList[elementList.length - 1].innerHTML = value;
			}
		},
	});
}
